import { Flex } from './base/layout-components';
import { getColor } from '../common/constants/_colors';
import Icon from './base/Icon';
import React from 'react';
import Text from 'components/base/Text';

const CopyTextArea = ({ text, height, width }) => (
  <Flex
    height={height}
    width={width}
    justify='space-between'
    backgroundColor={getColor('catskillGray')}
    padding='small'
    border={`1px solid ${getColor('silverSand')}`}
  >
    <Text
      weight='400'
      color='shuttleGray'
      size='normal'
      style={{ fontFamily: 'Courier', whiteSpace: 'pre', overflow: 'scroll' }}
    >
      {text}
    </Text>
    <Icon
      style={{ cursor: 'pointer' }}
      name='CopyIcon'
      color='shuttleGray'
      onClick={() => navigator.clipboard.writeText(text)}
    />
  </Flex>
);
export default CopyTextArea;
